/**
 * Rich text utilities (replacement for draft.js).
 * Content is stored and passed as HTML strings.
 */

import DOMPurify from 'dompurify'

/**
 * Empty editor content (HTML string).
 */
export const createEmptyEditorState = () => ''

/**
 * Normalize HTML for editor input. Sanitizes and wraps in paragraph if needed.
 */
export const HTMLToEditorState = htmlString => {
  if (htmlString == null || htmlString === '') return ''
  const sanitized = DOMPurify.sanitize(htmlString, { ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'div', 'span'], ALLOWED_ATTR: ['href', 'target', 'rel'] })
  const trimmed = sanitized.trim()
  if (!trimmed) return ''
  return trimmed
}

/**
 * For backward compatibility: accept HTML string or legacy editorState-like object.
 */
export const EditorStateToHTML = value => {
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'object' && value.__html != null) return value.__html
  return ''
}

/**
 * Sanitize HTML for safe display (e.g. preview).
 */
export const formatAndSanitizeHTML = html => DOMPurify.sanitize(html || '')

/**
 * Get the block element containing the current selection (for link menu positioning).
 */
export const getSelectedBlockElement = () => {
  const selection = window.getSelection()
  if (!selection || selection.rangeCount === 0) return null
  let node = selection.getRangeAt(0).startContainer
  do {
    if (node.getAttribute && node.getAttribute('data-block') === 'true') return node
    if (node.classList && node.classList.contains('ProseMirror')) return node
    node = node.parentNode
  } while (node != null)
  return null
}
